// 2023-01-18 by Rex

export type Method = 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';


export interface CreateFetchOption {
  method?: Method;
  params?: URLSearchParams;
  body?: BodyInit | null;
  headers?: Record<string, string>;
  timeout?: number;
  mode?: RequestMode;
  abort?: AbortController;
}


type Fetcher<T> = () => Promise<T>;


export class FetcherFactory<T> {
  private readonly option: CreateFetchOption;
  private readonly url: string;
  private bearer: string;
  private bearerKey: string;
  private abort: AbortController | undefined;


  constructor(url: string, option: CreateFetchOption) {
    this.url = url;
    this.option = option;
    this.bearer = '';
    this.bearerKey = '';
    this.abort = option.abort;
  }


  useAuthorizationBearer(key = 'token') {
    this.bearerKey = key;
    //  this.bearer = AuthHelper.getAuthorizationBearer(this.bearerKey);
    return this;
  }


  setAbortController(abort: AbortController) {
    this.abort = abort;
    return this;
  }


  create = (): Fetcher<T> => {
    const url = this.url;
    const option = this.option;


    const headers: Record<string, string> = {
      //  [HeadersEnum.Accept]: HeaderValueEnum.ApplicationJson,
      //  [HeadersEnum.ContentType]: HeaderValueEnum.ApplicationJson
    };

    if (this.bearer) {
      // TODO JWT Auth...
      //  headers[HeadersEnum.Authorization] = this.bearer;
    }

    if (option.headers) {
      for (const key of Object.keys(option.headers)) {
        headers[key] = option.headers[key];
      }
    }
    const mode: RequestMode = option.mode ? option.mode : 'cors';
    const method: Method = option.method ? option.method : 'GET';
    const body = option.body ? option.body : null;


    let params = new URLSearchParams();
    if (option.params) {
      params = option.params;
    }
    const query = `?${params.toString()}`;


    const input = query.length > 1 ? `${url}${query}` : url;


    const timeout = option.timeout ? option.timeout : 5000;


    const controller = this.abort ? this.abort : new AbortController();


    const tid = setTimeout(() => controller.abort(), timeout);


    return () => {
      return new Promise<T>((resolve, reject) => {
        fetch(input, { method, mode, headers, body, signal: controller.signal })
          .then(async (res) => {
            clearTimeout(tid);

            if (this.bearerKey) {
              //  const jwt = AuthHelper.getAuthorizationFromHeader(res.headers);
              //  if (jwt) {
              //    AuthHelper.saveJwtToCookie(this.bearerKey, jwt);
              //  }
            }

            if (res.ok) {
              return res.status === 204 ? await res.text() : await res.json();
            }

            const text = await res.text();
            // console.log(text);
            let err: ErrorMessageDTO | string = text;
            try {
              err = JSON.parse(text);
            } catch (_) {
              throw text;
            }
            throw err;
          })
          .then((data: T) => {
            return resolve(data);
          })
          .catch((err) => {
            return reject(err);
          });
      });
    };
  };
}

export interface ErrorMessageDTO {
  status: number;
  message: string;
  data: string;
}


export default FetcherFactory;
